<template>
  <!-- 工作台 -->
  <el-container class="home-container">
    <el-header class="homeHeader">
      <div>
        <el-image :src="imgUrl"></el-image>
      </div>
      <div style="display: flex; align-items: center">
        <span
          @click="modifyBtns"
          style="
            margin-right: 1rem;
            display: flex;
            font-size: 14px;
            align-items: center;
            color: #246deb;
            cursor: pointer;
          "
          >修改密码</span
        >
        <!-- <span @click="HrefClick" style="margin-right:1rem;">切换旧版</span> -->
        <span
          @click="HrefClick"
          style="
            margin-right: 1rem;
            display: flex;
            font-size: 14px;
            align-items: center;
          "
        >
          <p style="margin: 0">新版</p>
          <p style="margin: 0 3px">/</p>
          <p style="color: #246deb; margin: 0">切换旧版</p>
        </span>
        <span>
          <img src="../images/scenic/admin.png" alt srcset />
        </span>
        <span
          style="margin-right: 0.5rem; font-size: 1.4rem"
          @click="foundation"
          >{{ name }} {{ ScenicId }}</span
        >
        <span style="font-size: 1.4rem" @click="outFn">退出</span>
      </div>
    </el-header>
    <el-container>
      <el-aside width="260px">
        <el-menu
          :collapse-transition="false"
          background-color="#2A354D"
          text-color="#fff"
          active-text-color="#fff"
          router
        >
          <template v-for="v in menu">
            <template v-if="v.childrens">
              <el-submenu :index="v.path">
                <template slot="title">
                  <img
                    :src="v.icon"
                    alt
                    srcset
                    style="
                      width: 14px;
                      height: 14px;
                      color: white;
                      margin-right: 5px;
                    "
                  />
                  <span slot="title">{{ v.title }}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item
                    v-for="vv in v.childrens"
                    :index="'/' + vv.path"
                    :key="vv.id"
                    >{{ vv.title }}</el-menu-item
                  >
                </el-menu-item-group>
              </el-submenu>
            </template>
            <template v-else>
              <el-menu-item :index="'/' + v.path">
                <img
                  :src="v.icon"
                  alt
                  srcset
                  style="
                    width: 14px;
                    height: 14px;
                    color: white;
                    margin-right: 5px;
                  "
                />
                <span slot="title">{{ v.title }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
    <el-dialog
      :close-on-click-modal="false"
      title="密码修改"
      :visible.sync="paswordFlow"
      :before-close="paswordClose"
      width="27%"
      center
    >
      <el-divider></el-divider>
      <div class="pasword">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="用户名" prop="name">
            <el-input v-model="ruleForm.name" disabled></el-input>
          </el-form-item>
          <el-form-item label="旧密码" prop="old_password">
            <el-input
              v-model="ruleForm.old_password"
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="new_password">
            <el-input
              v-model="ruleForm.new_password"
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="sure_password">
            <el-input
              v-model="ruleForm.sure_password"
              type="password"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="form_btns">
          <div @click="clearRule">清空</div>
          <div @click="UpdateBtns('ruleForm')">确认添加</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="在线客服"
      :visible.sync="lineFlow"
      :before-close="lineClose"
      width="42%"
      center
    >
      <el-divider></el-divider>
      <div class="line_box">
        <div class="top" ref="dialogue">
          <div class="top_content">
            <div class="top_left">
              <img src="@/assets/logo2.png" alt="" />
              <div>
                你好，我是金飞鹰雪务通客服小金，欢迎咨询...
                <p
                  v-for="(item, index) in list"
                  :key="index"
                  @click="listBtns(item)"
                  v-if="index <= 9"
                >
                  {{ index }}、{{ item.title }}
                </p>
              </div>
            </div>
            <div class="huida" v-for="(itm, index) in Mylist" :key="index">
              <div class="top_right" v-if="itm.state == '1'">
                <div>
                  {{ itm.title }}
                </div>
                <img src="@/assets/user.png" alt="" />
              </div>
              <div class="top_left" v-if="itm.state == '2'">
                <img src="@/assets/logo2.png" alt="" />
                <div>
                  <span
                    @click="imageChagange($event)"
                    v-html="itm.title"
                  ></span>
                  <p
                    v-for="(items, idx) in itm.keywords"
                    :key="idx"
                    class="lint"
                    @click="keywod_btns(items)"
                  >
                    {{ items }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="line_border"></div>
        <div class="bottom">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 3 }"
            v-model="pint.keywords"
            @keyup.enter.native="send"
          ></el-input>
          <div class="guan" @click="lineClose">关闭</div>
          <div class="fa" @click="send">发送</div>
        </div>
      </div>
    </el-dialog>
    <!-- <div class="mask_boxs" v-if="flow">
        <div class="box_content">

        </div>
    </div> -->
    <img src="@/assets/kf.png" @click="zixun" alt="" class="posKfz" />
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="[url1]"
    />
    <div class="info_class_names">
      <scenicSetDialog
        v-if="infovisible"
        ref="infoDialog"
        @scenic="setClose"
      ></scenicSetDialog>
    </div>
  </el-container>
</template>

<script>
import { distributorLogout, updatePassword } from "@/request/login.js";
import {
  ScenicMessage,
  getServiceList,
  SMSstatistics,
  ScenicSMSstatistics,
} from "@/request/scenic.js";
import { Message } from "element-ui";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import scenicSetDialog from "../components/scenic/secenSet/dialog/scenicSetDialog.vue";
export default {
  components: {
    scenicSetDialog,
    ElImageViewer,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.sure_password !== "") {
          this.$refs.ruleForm.validateField("sure_password");
        }
        let re = /^[a-zA-Z]\w{6,17}$/;
        if (!re.test(value)) {
          callback(
            new Error(
              "请输入以字母开头,长度在6位以上的密码,只能包含字母、数字。"
            )
          );
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.new_password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        let re = /^[a-zA-Z]\w{6,17}$/;
        if (!re.test(value)) {
          callback(
            new Error(
              "请输入以字母开头,长度在6位以上的密码,只能包含字母、数字。"
            )
          );
        }
        callback();
      }
    };
    return {
      infovisible: false,

      infos: "",
      url1: "",
      showViewer: false,
      lineFlow: false,
      imgUrl: require("../images/scenic/logo.png"),
      // 景区菜单
      menu: [
        {
          id: 1,
          title: "工作台",
          path: "worke",
          icon: require("../images/scenic/gzt.png"),
        },
        {
          id: 2,
          title: "产品管理",
          path: "product",
          icon: require("../images/scenic/cp.png"),
          children: [
            {
              id: 2 - 1,
              title: "产品列表",
              path: "productList",
            },
            {
              id: 2 - 2,
              title: "产品分类",
              path: "productTypeList",
            },
            // {
            //   id: 2 - 2,
            //   title: "预定项目",
            //   path: "reservePro"
            // },
            // {
            //   id: 2 - 3,
            //   title: "预定订单审核",
            //   path: "reServeOrderSc"
            // },
            // {
            //   id: 2 - 4,
            //   title: "退票管理",
            //   path: "reTicket"
            // }
          ],
        },
        {
          id: 3,
          title: "分销管理",
          path: "retail",
          icon: require("../images/scenic/fx.png"),
          children: [
            {
              id: 3 - 1,
              title: "我的分销商",
              path: "retail",
            },
          ],
        },
        {
          id: 4,
          title: "营销管理",
          path: "Market",
          icon: require("../images/scenic/yx.png"),
          children: [
            {
              id: 4 - 1,
              title: "营销设置",
              path: "wShopping",
            },
            // {
            //   id: 2 - 1,
            //   title: "微商城",
            //   path: "wShopping"
            // },
            // {
            //   id: 2 - 2,
            //   title: "微餐饮",
            //   path: "wRestaurant"
            // },
            // {
            //   id: 2 - 3,
            //   title: "大转盘",
            //   path: "turntable"
            // },
            // {
            //   id: 2 - 4,
            //   title: "全民分销",
            //   path: "AllPeople"
            // }
          ],
        },
        {
          id: 5,
          title: "财务报表",
          path: "finance",
          icon: require("../images/scenic/cw.png"),
          children: [
            {
              id: 2 - 1,
              title: "订单管理",
              path: "order",
            },
            // {
            //   id: 2 - 2,
            //   title: "直销统计",
            //   path: "directSta"
            // },
            {
              id: 2 - 3,
              title: "短信统计",
              path: "noteSta",
            },
            {
              id: 2 - 4,
              title: "分销统计",
              path: "distribution",
            },
            {
              id: 2 - 5,
              title: "报表中心",
              path: "report",
            },
            // {
            //   id:2 - 6,
            //   title:'日历统计',
            //   path : 'date'
            // }
            // {
            //   id: 2 - 4,
            //   title: "预定统计",
            //   path: "reserveSta"
            // },
            // {
            //   id: 2 - 5,
            //   title: "运营分析",
            //   path: "operAnalysis"
            // },
            // {
            //   id: 2 - 6,
            //   title: "联名卡核销列表",
            //   path: "jointCard"
            // },
            // {
            //   id: 2 - 7,
            //   title: "订单明细查询",
            //   path: "orderQuery"
            // },
            // {
            //   id: 2 - 8,
            //   title: "打款列表",
            //   path: "PaymentList"
            // },
            // {
            //   id: 2 - 9,
            //   title: "发票列表",
            //   path: "invoiceList"
            // }
          ],
        },
        {
          id: 6,
          title: "微信管理",
          path: "WeChat",
          icon: require("../images/scenic/wx1.png"),
          children: [
            {
              id: 6 - 1,
              title: "微商城",
              path: "wcMall",
            },
            {
              id: 6 - 2,
              title: "微餐饮",
              path: "Mcatering",
            },
          ],
        },
        // {
        //   id: 6,
        //   title: "微信管理",
        //   path: "wxMange",
        //   icon: require("../images/scenic/wx.png"),
        //   children: [
        //     {
        //       id: 2 - 1,
        //       title: "微信内容",
        //       path: "wxContent"
        //     },
        //     {
        //       id: 2 - 2,
        //       title: "用户列表",
        //       path: "userList"
        //     },
        //     {
        //       id: 2 - 3,
        //       title: "相册管理",
        //       path: "albumMange"
        //     }
        //   ]
        // },
        {
          id: 8,
          title: "系统设置",
          path: "system",
          icon: require("../images/scenic/xt.png"),
          children: [
            {
              id: 2 - 1,
              title: "景区设置",
              path: "scenicSet",
            },
            {
              id: 2 - 2,
              title: "权限管理",
              path: "rightMan",
            },
            {
              id: 2 - 3,
              title: "合作方设置",
              path: "cooperation",
            },
            {
              id: 2 - 4,
              title: "供应方设置",
              path: "providerSet",
            },
          ],
        },
      ],
      btnStyle: {
        top: "50%",
        right: "0",
      },
      name: "",
      ScenicId: "",
      paswordFlow: false,
      ruleForm: {
        token: window.sessionStorage.getItem("Token"),
        name: "",
        new_password: "",
        sure_password: "",
        old_password: "",
      },
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        old_password: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        sure_password: [{ validator: validatePass2, trigger: "blur" }],
        new_password: [{ validator: validatePass, trigger: "blur" }],
      },
      list: [],
      Mylist: [],
      pint: {
        token: window.sessionStorage.getItem("Token"),
        page: 1,
        page_size: 99,
        title: "",
        keywords: "",
        cs_id: "",
      },
    };
  },
  beforeCreate() {
    // 优先检查 dataId
    const urlParams = new URLSearchParams(window.location.search);
    const dataId = urlParams.get('dataId');
    
    if (dataId) {
      // 从 sessionStorage 获取数据
      const datas = JSON.parse(window.sessionStorage.getItem(decodeURIComponent(dataId)));
      
      if (datas) {
        window.sessionStorage.removeItem("Token");
        this.navList = datas.permission;
        window.sessionStorage.setItem("menue", JSON.stringify(this.navList));
        window.sessionStorage.setItem("Token", datas.token);
        window.sessionStorage.setItem("path", "/login");
        window.sessionStorage.setItem("index", datas.index);
        
        // 清理 sessionStorage
        window.sessionStorage.removeItem(decodeURIComponent(dataId));
      }
    }
    
    if (this.$route.query.data) {
      window.sessionStorage.removeItem("Token");
      let datas = JSON.parse(this.$route.query.data);
      this.navList = datas.permission;
      window.sessionStorage.setItem("menue", JSON.stringify(this.navList));
      window.sessionStorage.setItem("Token", datas.token);
      window.sessionStorage.setItem("path", "/login");
      window.sessionStorage.setItem("index", datas.index);
    }
  },
  created() {
    console.log("menu", this.menu);
    if (window.sessionStorage.getItem("is_pwd") == "0") {
      this.paswordFlow = true;
    }
    let data = {
      token: window.sessionStorage.getItem("Token"),
    };
    ScenicMessage(data).then((res) => {
      if (res.data.status == "ok") {
        this.infos = res.data.result;
        this.name = res.data.result.Name;
        this.ruleForm.name = res.data.result.Name;
        this.ScenicId = res.data.result.scenic_id;
        window.sessionStorage.setItem("ScenicId", res.data.result.scenic_id);
        window.sessionStorage.setItem("is_id", res.data.result.Status);
      }
    });
    let Mmen = this.menu;
    let menu = JSON.parse(window.sessionStorage.getItem("menue"));
    let arr = [];
    arr.push(Mmen[0]);
    Mmen.map((item) => {
      menu.map((itm) => {
        if (item.title == itm.title) {
          arr.push(item);
        }
      });
    });
    arr.map((item) => {
      this.$set(item, "childrens", []);
      menu.map((itm) => {
        if (item.title == itm.title) {
          if (item.children) {
            item.children.map((items) => {
              itm.son.map((itms) => {
                if (itms.title == items.title) {
                  item.childrens.push(items);
                }
              });
            });
          }
        }
      });
    });
    arr.map((item) => {
      if (item.title == "产品管理") {
        if (item.title == "产品管理") {
          item.childrens.push({
            id: 2 - 2,
            path: "ticket",
            title: "组合子产品",
          });
        }
        item.childrens.push({
          id: 2 - 3,
          path: "recycle",
          title: "回收站",
        });
      }
    });
    arr.map((item) => {
      if (item.title == "财务报表") {
        item.childrens.push({
          id: 5 - 6,
          path: "dylist",
          title: "抖音核销列表",
        });
        item.childrens.push({
          id: 5 - 7,
          path: "ording",
          title: "批量订单列表",
        });
      }
      if (item.title == "财务报表") {
        item.childrens.push({
          id: 2 - 7,
          title: "撤销核销",
          path: "revoke",
        });
        item.childrens.push({
          id: 2 - 2,
          title: "小程序订单列表",
          path: "miniOrder",
        });
        item.childrens.push({
          id: 2 - 9,
          title: "套票统计",
          path: "comboStatistics",
        });
      }
    });
    this.menu = arr;
    let datas = {
      token: window.sessionStorage.getItem("Token"),
    };
    ScenicMessage(datas).then((res) => {
      if (res.data.status == "ok") {
        if (res.data.result.scenic_id == "117") {
          this.menu.map((item) => {
            if (item.title == "微信管理") {
              const extra = [{ id: 6 - 3, path: "cinema", title: "院线观影" }];
              this.$set(item, "childrens", [...(item.childrens || []), ...extra]);
            }
          });
        }
        if (res.data.result.scenic_id == "397" || res.data.result.scenic_id == "409" || res.data.result.scenic_id == "128") {
          this.menu.map((item) => {
            if (item.title == "营销管理") {
              const extra = [
                { id: 4 - 2, title: "信息发布", path: "infos" },
                { id: 4 - 3, title: "留言板", path: "leave" },
                { id: 4 - 4, title: "失物招领", path: "lost" },
                { id: 4 - 5, title: "产品管理", path: "yinProduct" },
                { id: 4 - 6, title: "订单列表", path: "yinorder" },
              ];
              this.$set(item, "childrens", [...(item.childrens || []), ...extra]);
            }
          });
        }
      }
      // 等 ScenicMessage 返回后再做清理和追加，避免登录后菜单不刷新的问题
      this.menu.map((item) => {
        if (item.childrens && item.childrens.length == 0) {
          delete item.childrens;
        }
      });
      this.menu.push({
        icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADqSURBVHgBpVNrEYJAEN5j+O81kAhEwAY0UBvYQBuoDTSBmAAbnA2kATTAb509XRAFdGe+2b19P8DUdb0mohSoaBxZICMkyOlHQqwLBjjZL+YqEKcTEHUEL8BcOwn7SufWK1I9CgcACeuADbDVBaRg2q7GzlMJLoEdEMubk9yEW11M7+BxBWMM8z1QQr7K+wAUwq3InTNpndO7kH08bX6kEMIKfA4sqUm2sSiis7KxL+/h6LO9nUrmjUVOP1zC/fsh5aGvRuNpAkRGWkvoNesYyoxqJ+GMAwMLnPfCQu+/0EemrehbKirP9PsOL2rSRrt0d5MAAAAASUVORK5CYII=",
        id: 8,
        path: "xcx",
        title: "核销小程序管理",
      });
    });
  },
  methods: {
    setClose() {
      let data = {
        token: window.sessionStorage.getItem("Token"),
      };
      ScenicMessage(data).then((res) => {
        if (res.data.status == "ok") {
          this.infos = res.data.result;
          this.name = res.data.result.Name;
          this.ruleForm.name = res.data.result.Name;
          this.ScenicId = res.data.result.scenic_id;
          window.sessionStorage.setItem("ScenicId", res.data.result.scenic_id);
          window.sessionStorage.setItem("is_id", res.data.result.Status);
        }
      });
      this.infovisible = false;
    },
    foundation() {
      this.infovisible = true;
      this.$nextTick(() => {
        this.$refs.infoDialog.infoSet(this.infos);
      });
    },
    closeViewer() {
      this.showViewer = false;
      this.url1 = "";
    },
    imageChagange(e) {
      if (e.target.nodeName === "IMG" || e.target.nodeName == "img") {
        //判断是否图片标签
        const img = e.target.currentSrc; //获取点击图片地址
        this.url1 = img;
        this.showViewer = true;
      }
    },
    listBtns(item) {
      this.Mylist.push({
        title: item.title,
        state: 1,
      });
      this.$nextTick(function () {
        var p = this.$refs.dialogue;
        p.scrollTop = p.scrollHeight;
      });
      setTimeout(() => {
        if (item.keywords_flag == "2") {
          let data = {
            token: window.sessionStorage.getItem("Token"),
            page: 1,
            page_size: 99,
            title: "",
            keywords: "",
            cs_id: "",
          };
          let keys = [];
          getServiceList(data).then((res) => {
            if (res.data.status == "ok") {
              item.cs_id.split(",").map((itms) => {
                res.data.result.data.map((im) => {
                  if (im.id == itms) {
                    keys.push(im.title);
                  }
                });
              });
            }
          });
          this.Mylist.push({
            title: item.content,
            keywords: keys,
            state: 2,
          });
          this.$nextTick(function () {
            var p = this.$refs.dialogue;
            p.scrollTop = p.scrollHeight;
          });
        } else {
          this.Mylist.push({
            title: item.content,
            state: 2,
          });
          this.$nextTick(function () {
            var p = this.$refs.dialogue;
            p.scrollTop = p.scrollHeight;
          });
        }
        this.$nextTick(function () {
          var p = this.$refs.dialogue;
          p.scrollTop = p.scrollHeight;
        });
      }, 1000);
      this.$nextTick(function () {
        var p = this.$refs.dialogue;
        p.scrollTop = p.scrollHeight;
      });
    },
    zixun() {
      this.lineFlow = true;
      this.serverList();
    },
    serverList() {
      getServiceList(this.pint).then((res) => {
        if (res.data.rcode == 200) {
          this.list = res.data.result.data;
        }
      });
    },
    send() {
      if (this.pint.keywords == "") {
        Message.error("请输入");
        return false;
      }
      this.Mylist.push({
        title: this.pint.keywords,
        state: 1,
      });
      this.$nextTick(function () {
        var p = this.$refs.dialogue;
        p.scrollTop = p.scrollHeight;
      });
      this.sendList();
      this.pint.keywords = "";
    },
    sendList() {
      getServiceList(this.pint).then((res) => {
        if (res.data.rcode == 200) {
          if (res.data.result.data.length == 0) {
            this.Mylist.push({
              title: "查询条件不匹配",
              state: 2,
            });
            this.$nextTick(function () {
              var p = this.$refs.dialogue;
              p.scrollTop = p.scrollHeight;
            });
            return false;
          }
          this.Mylist.push({
            title: res.data.result.data[0].content,
            state: 2,
          });
          this.$nextTick(function () {
            var p = this.$refs.dialogue;
            p.scrollTop = p.scrollHeight;
          });
        }
      });
    },
    lineClose() {
      this.lineFlow = false;
    },
    keywod_btns(itm) {
      let data = {
        token: window.sessionStorage.getItem("Token"),
        title: itm,
      };
      getServiceList(data).then((res) => {
        if (res.data.status == "ok") {
          this.Mylist.push({
            title: itm,
            state: 1,
          });
          this.$nextTick(function () {
            var p = this.$refs.dialogue;
            p.scrollTop = p.scrollHeight;
          });
          let keys = [];
          res.data.result.data.map((item) => {
            this.list.map((items) => {
              if (item.cs_id) {
                item.cs_id.split(",").map((imli) => {
                  if (imli == items.id) {
                    keys.push(items.title);
                  }
                });
              }
            });
          });
          this.Mylist.push({
            title: res.data.result.data[0].content,
            state: 2,
            keywords: keys,
          });
          this.$nextTick(function () {
            var p = this.$refs.dialogue;
            p.scrollTop = p.scrollHeight;
          });
        }
      });
    },
    UpdateBtns(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updatePassword(this.ruleForm).then((res) => {
            if (res.data.status == "ok") {
              Message.success("修改成功");
              this.paswordFlow = false;
              window.sessionStorage.removeItem("is_pwd");
              this.ruleForm = {
                token: window.sessionStorage.getItem("Token"),
                name: this.ruleForm.name,
                new_password: "",
                sure_password: "",
                old_password: "",
              };
            } else {
              Message.error(res.data.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    clearRule() {
      this.ruleForm = {
        token: window.sessionStorage.getItem("Token"),
        name: this.ruleForm.name,
        new_password: "",
        sure_password: "",
        old_password: "",
      };
    },
    modifyBtns() {
      this.paswordFlow = true;
    },
    paswordClose() {
      this.paswordFlow = false;
      window.sessionStorage.removeItem("is_pwd");
      this.ruleForm = {
        token: window.sessionStorage.getItem("Token"),
        name: this.ruleForm.name,
        new_password: "",
        sure_password: "",
        old_password: "",
      };
    },
    HrefClick() {
      // let href = 'http://home.softykt.net/'
      let href = "http://home.softykt.net/";
      window.open(href);
    },
    // 点击退出
    outFn() {
      let data = {
        token: window.sessionStorage.getItem("Token"),
      };
      distributorLogout(data).then((res) => {
        if (res.data.status == "ok") {
          this.$message.success("退出登录");
          window.sessionStorage.removeItem("Token");
          window.sessionStorage.removeItem("menue");
          this.$router.push("/login");
        }
      });
    },
  },
};
</script>

<style lang='less' scoped>
.active {
  background-color: rgba(36, 109, 235, 0.4);
}
//设置了行高和字体大小、高度颜色
/deep/.el-menu-item {
  font-size: 14px;
  height: 52px;
  line-height: 52px;
  color: #666666;
  transition: none !important;
}
//子节点选中样式(前面只有一级，后面子级)
/deep/.el-menu-item.is-active,
.el-submenu .el-menu-item.is-active {
  background-color: rgba(36, 109, 235, 0.4) !important;
}
.home-container {
  height: 100vh;
}
.el-header {
  background-color: #001529;
  color: white;
}
.homeHeader {
  display: flex;
  justify-content: space-between;
  > div:nth-child(1) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  > div:nth-child(2) {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    > span:nth-child(1) {
      .img {
        width: 12px;
        height: 12px;
      }
    }
    > span:nth-child(2) {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      /* identical to box height */
      color: #ffffff;
      margin: 0 19px 0 8px;
    }
    > span:nth-child(3) {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      /* identical to box height */

      color: #ffffff;
    }
  }
}

.el-aside {
  background-color: #2a354d;
}
.el-main {
  background: #f7f7fa;
}
/deep/ .el-dialog__title {
  font-weight: 400 !important;
  color: #000 !important;
  font-family: OPPOSans !important;
  font-size: 2rem !important;
}
.form_btns {
  margin-top: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  > div {
    width: 10rem;
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 1.4rem;
    border-radius: 0.4rem;
    cursor: pointer;
    &:nth-child(1) {
      background: #d9d9d9;
    }
    &:nth-child(2) {
      background: #246deb;
      margin-left: 2rem;
    }
  }
}
.posKfz {
  width: 8rem;
  height: 10rem;
  border-radius: 0.8rem;
  cursor: pointer;
  position: fixed;
  top: 50%;
  right: -3.5rem;
  transform: translate(0, -50%);
}
.posKfz:hover {
  right: 0;
}
.line_box {
  width: 100%;
  height: 59.1rem;
  border: 1px solid #e5e5ea;
  .top {
    height: 43.1rem;
    overflow-y: auto;
    padding: 2rem;
    box-sizing: border-box;
    > div {
      color: #797979;
      font-size: 1.4rem;
      text-align: center;
      margin-bottom: 2rem;
    }
    .top_content {
      display: flex;
      flex-direction: column;
      .top_left {
        display: flex;
        align-items: center;
        margin-bottom: 2rem;
        img {
          width: 4rem;
          height: 4rem;
        }
        > div {
          margin-left: 1rem;
          padding: 1rem;
          border: 1px solid #e5e5ea;
          border-radius: 0.4rem;
          color: #000000;
          font-size: 1.4rem;
          p {
            text-align: left;
            color: #246deb;
            cursor: pointer;
            margin: 0.6rem 0 0 0;
          }
        }
      }
      .huida {
        display: flex;
        .top_right {
          display: flex;
          align-items: center;
          margin-left: auto;
          margin-bottom: 2rem;
          img {
            width: 4rem;
            height: 4rem;
          }
          > div {
            padding: 1rem;
            background: #246deb;
            border-radius: 0.4rem;
            margin-right: 1rem;
            color: #fff;
            font-size: 1.4rem;
          }
        }
        .top_left {
          display: flex;
          align-items: center;
          margin-bottom: 2rem;
          img {
            width: 4rem;
            height: 4rem;
          }
          > div {
            text-align: left;
            margin-left: 1rem;
            padding: 1rem;
            border: 1px solid #e5e5ea;
            border-radius: 0.4rem;
            color: #000000;
            font-size: 1.4rem;
            p {
              text-align: left;
              color: #246deb;
              cursor: pointer;
            }
            ::v-deep img {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .line_border {
    width: 100%;
    height: 0.4rem;
    background: #e5e5ea;
  }
  .bottom {
    height: 15.6rem;
    padding: 2rem;
    position: relative;
    ::v-deep .el-textarea__inner {
      height: 100% !important;
      border: none;
      resize: none;
    }
    .guan {
      width: 9.6rem;
      height: 4rem;
      border: 2px solid #246deb;
      color: #246deb;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.4rem;
      position: absolute;
      bottom: 2rem;
      right: 14rem;
      border-radius: 0.4rem;
      cursor: pointer;
    }
    .fa {
      width: 10rem;
      height: 4rem;
      background: #246deb;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.4rem;
      position: absolute;
      bottom: 2rem;
      right: 2rem;
      border-radius: 0.4rem;
      cursor: pointer;
    }
  }
}
.info_class_names /deep/.infoFrom {
  border-top: 1px solid #dcdfe6 !important;
  padding-top: 2rem !important;
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
.mask_boxs {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99999;
  .box_content {
    width: 40rem;
    height: 30rem;
    background: #fff;
  }
}
</style>